<ng-container [ngSwitch]="element.item.type" *ngFor="let element of elements || []; index as i">
  <ng-container *ngSwitchCase="'rich_text_section'">
    <result-rich-text-section (invoke)="invoke.emit($event)" [model]="element.item" [highlights]="highlights" [borderRadius]="element.radiusType"> </result-rich-text-section>
  </ng-container>

  <ng-container *ngSwitchCase="'rich_text_list'">
    <result-rich-text-list (invoke)="invoke.emit($event)" [model]="element.item" [highlights]="highlights" [borderRadius]="element.radiusType"> </result-rich-text-list>
  </ng-container>

  <ng-container *ngSwitchCase="'rich_text_quote'">
    <result-rich-text-quote (invoke)="invoke.emit($event)" [model]="element.item" [highlights]="highlights" [borderRadius]="element.radiusType"> </result-rich-text-quote>
  </ng-container>

  <ng-container *ngSwitchCase="'rich_text_preformatted'">
    <result-rich-text-preformatted (invoke)="invoke.emit($event)" [model]="element.item" [highlights]="highlights" [borderRadius]="element.radiusType"> </result-rich-text-preformatted>
  </ng-container>
</ng-container>
